import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import { CATEGORIES } from '../mock';

const NotFound = () => (
  <>
    <SEO
      title="Page introuvable"
      description="La page que vous cherchez n'existe pas ou a été déplacée. Retrouvez nos récits sur BcoolStore."
      url="/404"
      noIndex
    />
    <main
      className="max-w-3xl mx-auto px-4 md:px-8 py-16 md:py-24 text-center"
      data-testid="notfound-page"
    >
      <div className="text-[11px] uppercase tracking-[0.4em] text-[#c9a961] font-semibold mb-3">
        Erreur 404
      </div>
      <h1
        className="text-[48px] md:text-[72px] font-bold text-[#1a1414] italic leading-none mb-4"
        style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
      >
        Page <span className="text-[#8b2c3f]">introuvable</span>
      </h1>
      <div className="h-[3px] w-14 bg-[#c9a961] mx-auto mb-8" />
      <p
        className="text-[18px] md:text-[20px] text-[#3a3232] italic leading-relaxed max-w-xl mx-auto mb-10"
        style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
      >
        La page que vous cherchez semble avoir tourné la page.
        Peut-être a-t-elle été déplacée, renommée, ou n&apos;a-t-elle jamais existé.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-14">
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="inline-flex items-center gap-2 bg-[#8b2c3f] hover:bg-[#6d1f2f] text-white text-[12px] uppercase font-semibold tracking-[0.22em] px-6 py-3 transition-colors"
        >
          <Home size={14} /> Retour à l&apos;accueil
        </Link>
        <Link
          to="/category/chroniques"
          data-testid="notfound-chroniques-link"
          className="inline-flex items-center gap-2 border border-[#1a1414] text-[#1a1414] hover:bg-[#1a1414] hover:text-white text-[12px] uppercase font-semibold tracking-[0.22em] px-6 py-3 transition-colors"
        >
          <Search size={14} /> Parcourir les chroniques
        </Link>
      </div>

      <div className="text-left">
        <div className="text-[12px] uppercase tracking-[0.22em] text-[#7a716c] font-bold mb-4 text-center">
          Ou explorez nos rubriques
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {CATEGORIES.filter((c) => c.slug !== 'home').map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              data-testid={`notfound-cat-${c.slug}`}
              className="group border border-[#e6ddd0] bg-white hover:border-[#8b2c3f] p-4 transition-colors flex items-center justify-between"
            >
              <span
                className="text-[15px] font-bold text-[#1a1414] group-hover:text-[#8b2c3f] transition-colors"
                style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
              >
                {c.name}
              </span>
              <ArrowRight
                size={14}
                className="text-[#c9a961] group-hover:translate-x-1 transition-transform"
              />
            </Link>
          ))}
        </div>
      </div>
    </main>
  </>
);

export default NotFound;
